<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex sm12 xs12 md12 lg12 grid-list-md>
                <v-form ref="formFormulario">
                    <v-container py-0>
                        <v-layout wrap>
                            <v-flex xs12 md12>
                                <v-select :label="cboAplicacao" :items="lista.aplicacao" return-object v-model="aplicacao"
                                    item-value="id" item-text="description" :no-data-text="cboAplicacaoSemDados"
                                    required :rules="rules.aplicacao"></v-select>
                            </v-flex>                                    

                            <v-flex xs12 md12>
                                <v-text-field :label="inputCodigoUnico" readonly
                                    :rules="rules.uniqueCode" v-model="uniqueCode"/>
                            </v-flex>         

                            <v-flex xs12 md12>
                                <v-text-field :label="inputDescricao" 
                                    :rules="rules.description" v-model.trim="descricao"/>
                            </v-flex>                             
                        </v-layout>
                    </v-container>
                </v-form>   
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import FormMixin from '@/mixin/form'
import ApiApplication from '@/api/identityProvider/application'

import ApiObject from '@/api/identityProvider/object'
import ApiObjectType from '@/api/identityProvider/object-type'

import ObjectModel from '@/model/identity-provider/object'
import ObjectTypeConstants from '@/constants/controle-acesso/object-type'

export default {
    name: "objeto-formulario",
    mixins: [ FormMixin ], 
    props: {
        value:{
            type: Object,
            required: false
        }
    }, 
    watch:{
        aplicacao(newValue){
            let formulario = this.$_.clone(this.value);
            formulario.application = newValue; 
            this.$emit("input", formulario);
        },
        descricao(newValue){
            let formulario = this.$_.clone(this.value);
            formulario.description = newValue; 
            this.$emit("input", formulario);
        }        
    },
    data(){
        return {
            rules:{
                aplicacao: [
                    val => {
                        if((val || null) == null)
                            return this.cboAplicacaoOrigatoria;

                        return true;
                    }
                ],                       
                uniqueCode: [
                    val => {
                        if((val || null) == null)
                            return this.ruleCodigoUnico;

                        return true;
                    }
                ],                               
                description: [
                    val => {
                        if((val || null) == null)
                            return this.ruleDescricao;

                        return true;
                    }
                ]
            },
            lista:{
                formulario: [],
                aplicacao: []
            },
            aplicacao: null,
            descricao: null,
            formulario: new ObjectModel().returnModel(),
            formularioObjectType: null
        }
    },  
    async mounted(){
        const loading = this.showLoading();
        await this.listarAplicacao();

        await this.listarTipoObjeto();
        await this.listarObjeto();
        
        loading.close();
    },          
    computed: { 
        cboAplicacao(){
            return this.$t('Views.ControleAcesso.Formulario.Editar.aplicacao')            
        },
        cboAplicacaoSemDados(){
            return this.$t('Views.ControleAcesso.Formulario.Editar.aplicacao-sem-dados')            
        },                     
        cboAplicacaoOrigatoria(){
            return this.$t('Views.ControleAcesso.Formulario.Editar.rule-aplicacao')            
        },         
        inputCodigoUnico(){
            return this.$t('Views.ControleAcesso.Formulario.Editar.codigo-unico')
        },
        ruleCodigoUnico(){
            return this.$t('Views.ControleAcesso.Formulario.Editar.rule-codigo-unico')            
        },        
        inputDescricao(){
            return this.$t('Views.ControleAcesso.Formulario.Editar.descricao')            
        },
        ruleDescricao(){
            return this.$t('Views.ControleAcesso.Formulario.Editar.rule-descricao')            
        },         
        uniqueCode(){
            let formulario = this.$_.clone(this.value);
            if(this.formularioObjectType != null){
                if(this.formulario != null && this.formulario.application != null){
                    const prefix = `${this.formularioObjectType.uniqueCode}.${this.formulario.application.uniqueCode}`;
                    let sequence = this.$_.sortBy(this.lista.formulario.map(
                        o => {
                            if(o.uniqueCode.indexOf(prefix) >= 0){
                                return this.$_.parseInt(o.uniqueCode.substr(prefix.length + 1));
                            }                            
                            else 
                                return 0;
                        }
                    ));

                    let max = 0;
                    if(sequence.length != 0)
                        max = sequence[sequence.length - 1];

                    formulario.uniqueCode = `${prefix}.${this.$_.padStart(max + 1, 5, '0')}`;
                }
            }
            else
                formulario.uniqueCode = "";

            this.$emit("input", formulario);  
            return formulario.uniqueCode;          
        }            
    }, 
    methods:{
        async listarTipoObjeto(){
            const resultado = await ApiObjectType.listarPorCodigoUnico(ObjectTypeConstants.formulario).catch(erro => this.showSnackbarError(erro.error));
            if(resultado.success){
                this.$set(this, "formularioObjectType", resultado.data);
            }
        },
        async listarAplicacao(){
            const resultado = await ApiApplication.listar().catch(erro => this.showSnackbarError(erro.error));
            if(resultado.success){
                this.$set(this.lista, "aplicacao", resultado.data);
            }
        },
        async listarObjeto(){
            const resultado = await ApiObject.listarPorTipoObjeto(this.formularioObjectType.id).catch(erro => this.showSnackbarError(erro.error));
            if(resultado.success){
                this.$set(this.lista, "formulario", resultado.data);
            }
        }                
    }   
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/material-dashboard/variables";

</style>
